import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame: number;
  fps: number;
}

export const GraphicNewsIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon,
  frame,
  fps,
}) => {
  return (
          <div
            style={{
              width: "100%",
              padding: "50px 20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
            }}
          >
            {/* Confetti triangles */}
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="#FFE600"
              style={{ position: "absolute", top: "10px", left: "40px", transform: "rotate(15deg)" }}
            >
              <polygon points="12,2 22,22 2,22" />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#111625"
              style={{ position: "absolute", top: "20px", right: "60px", transform: "rotate(-30deg)" }}
            >
              <polygon points="12,2 22,22 2,22" />
            </svg>

            {/* Slanted Title Badge */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                transform: "skewX(-8deg) rotate(-2deg)",
                width: "90%",
                marginBottom: "40px",
              }}
            >
              {/* BREAKING Ribbon */}
              <div
                style={{
                  background: "#FFE600",
                  border: "4px solid #000000",
                  padding: "4px 24px",
                  zIndex: 2,
                  alignSelf: "flex-start",
                  boxShadow: "5px 5px 0px rgba(0,0,0,0.15)",
                }}
              >
                <span
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: "44px",
                    fontWeight: 900,
                    color: "#000000",
                    letterSpacing: "4px",
                    textTransform: "uppercase",
                    display: "block",
                    lineHeight: 1,
                  }}
                >
                  BREAKING
                </span>
              </div>

              {/* NEWS/HEADLINE Ribbon */}
              <div
                style={{
                  background: "#111625",
                  border: "4px solid #000000",
                  padding: "12px 28px",
                  marginTop: "-6px",
                  width: "100%",
                  zIndex: 1,
                  boxShadow: "6px 6px 0px rgba(0,0,0,0.2)",
                  boxSizing: "border-box",
                }}
              >
                <h1
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: "84px",
                    fontWeight: 900,
                    color: "#FFFFFF",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    lineHeight: 1.0,
                    margin: 0,
                    textAlign: "left",
                  }}
                >
                  {headline}
                </h1>
              </div>
            </div>

            {/* Megaphone icon below */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2"
                style={{ transform: "rotate(-15deg)" }}
              >
                {/* Custom Mega-Phone Vector */}
                <path
                  d="M3 18V6H7L12 3V21L7 18H3Z"
                  fill="#111625"
                  stroke="#000000"
                  strokeWidth="1.5"
                />
                <path
                  d="M12 8C14 8 16 10 16 12C16 14 14 16 12 16"
                  stroke="#FFE600"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
                <path
                  d="M18 5C21 7.5 21 16.5 18 19"
                  stroke="#FFE600"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
